import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'address'
  static label = 'organisation_name'

  static get fields () {
    return {
      id: new UUID(),
      first_name: new STRING(),
      middle_name: new STRING(),
      last_name: new STRING(),
      organisation_name: new STRING(),
      address_line1: new STRING(),
      address_line2: new STRING(),
      sorting_code: new STRING(),
      postal_code: new STRING(),
      dependent_locality: new STRING(),
      locality: new STRING(),
      administrative_area: new STRING(),
      country: new STRING('AU'),
      phone: new STRING(),
      email: new STRING(),
      address_hash: new STRING()
    }
  }
}
